<div *ngIf="errorMaximumFiles || maximumFiles === 0" class="container-errorMaximumFiles">
	<span> {{ maximumFiles }} files maximum </span>
</div>
<div class="container" rbDragAndDrop (fileDropped)="onFileDropped($event)">
	<input
		type="file"
		#fileDropRef
		id="fileDropRef"
		multiple
		[accept]="accept"
		(change)="fileBrowseHandler($event.target.files)"
	/>
	<img src="assets/images/dnd/ic-upload-file.svg" alt="" />
	<h3>Drag and drop file here</h3>
	<h3>or</h3>
	<label for="fileDropRef">Browse for file</label>
</div>
<div class="files-list">
	<div class="single-file" *ngFor="let file of files; let i = index">
		<img src="assets/images/dnd/ic-file.svg" width="45px" alt="file" />
		<div class="info">
			<h4 class="name">
				{{ file?.name }}
			</h4>
			<p class="size">
				{{ formatBytes(file?.size) }}
			</p>
		</div>
		<img src="assets/images/dnd/ic-delete-file.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)" />
	</div>
</div>
<div *ngIf="files.length > 0" class="container-button-files">
	<button type="button" (click)="saveFiles()">Upload Files</button>
</div>
